/* eslint-disable no-console */
import {
  Conversation,
  Environment
} from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import { GetCommunicationsRequest } from "./interfaces/get-communications";

const defaultResultCount = 500;
const defaultStartingPoint = 1;

export async function getCommunications(
  data: GetCommunicationsRequest,
  env: Environment
): Promise<Conversation | ResponseError> {
  const postData = {
    requestedCount: data.requestedCount || defaultResultCount,
    startingPoint: data.startingPoint || defaultStartingPoint,
    coxAutoPartyId: data.customerId.toString(),
    consumerRecordSystem: data.consumerRecordSystem
  };
  const url = `${getBaseUrl(env)}CxM/message-details`;

  const header = await getHeader();

  const response = await fetchWrapper.postAsync<Conversation>(
    url,
    postData,
    header
  );
  if (response && response.data && !response.hasError) {
    return response.data;
  } else {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error,
      url
    };
    return error;
  }
}

export async function getCommunicationsV2(
  data: GetCommunicationsRequest,
  env: Environment
): Promise<Conversation> {
  const requestedCount = data.requestedCount || defaultResultCount;
  const startingPoint = data.startingPoint || defaultStartingPoint;
  const url = `${getBaseUrl(env)}CxM/message-details?consumerId=${
    data.customerId
  }&ConsumerRecordSystem=${
    data.consumerRecordSystem
  }&page=${startingPoint}&pageSize=${requestedCount}`;

  const header = await getHeader(2);

  const response = await fetchWrapper.getAsync<Conversation>(url, header);
  if (response && response.data && !response.hasError) {
    return response.data;
  } else {
    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error,
      url
    };
    throw error;
  }
}
